import get from 'lodash.get';
import set from 'lodash.set';
import merge from 'lodash.merge';

import type { DependenciesFormValues, FormValues } from '../../types/FormValues';
import type { SectionDependsOnDescriptor } from '../../sections/types';
import type { FieldDependsOnDescriptor } from '../../fields/types/common';

export const getDependenciesValues = (
  values: FormValues,
  sectionKey: string,
  dependsOn: FieldDependsOnDescriptor[] | SectionDependsOnDescriptor[] = []
): DependenciesFormValues => dependsOn.reduce((acc, dependency) => {
    if ('$or' in dependency) {
      const orDependencyValues = getDependenciesValues(values, sectionKey, dependency.$or);
      return merge(acc, orDependencyValues);
    }
    if ('$and' in dependency) {
      const andDependencyValues = getDependenciesValues(values, sectionKey, dependency.$and);
      return merge(acc, andDependencyValues);
    }
    if ('sectionKey' in dependency && 'fieldKey' in dependency) {
      set(
        acc,
        [dependency.sectionKey, ...dependency.fieldKey.split('.')],
        get(values, [dependency.sectionKey, ...dependency.fieldKey.split('.')])
      );
      return acc;
    }
    if ('sectionKey' in dependency) {
      acc[dependency.sectionKey] = values[dependency.sectionKey];
      return acc;
    }
    if ('fieldKey' in dependency) {
      set(
        acc,
        dependency.fieldKey.split('.'),
        get(values, [sectionKey, ...dependency.fieldKey.split('.')])
      );
      return acc;
    }
    if ('all' in dependency) {
      Object.assign(acc, values);
      return acc;
    }

    return acc;
  }, {} as DependenciesFormValues);
